import { SimpleSchema2Bridge } from 'uniforms-bridge-simple-schema-2'
import SimpleSchema from '../schema'

const ForgotPasswordSchema = new SimpleSchema({ email: { type: String, regEx: SimpleSchema.RegEx.Email, label: 'Email' } })

export default new SimpleSchema2Bridge(ForgotPasswordSchema)
